import { modalZIndex } from '@sass/globals.module.scss';
import { type BeaconConfig } from './types';

export const defaultConfig: BeaconConfig = {
  display: {
    zIndex: parseInt(modalZIndex, 10) + 5,
  },
};
